/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Box } from '@mui/material';
import axios from 'api/request';
import { useMutation } from 'react-query';
import { endPoints } from 'api/endpoints';
import { catalogs } from 'store';
import { isReadyToGetCost, resetCostEstimateDetails } from 'pages/myidm/utils';
import StickyHeader from 'pages/provisioning/_components/StickyHeader';
import { useRecoilState } from 'recoil';
import ProvisioningStyles from 'pages/myidm/style';
import {
    OrderPayload,
    costEstimateState,
    isAppShortNameValid,
    isAppShortNameExist,
    isAppNameValid,
    selectedMembersList,
    costApiLoading,
} from 'pages/myidm/store';
import { costPayload } from 'pages/myidm/utils/getPayload';
import { AD_GROUP, PRIVILEGED } from 'pages/myidm/utils/constant';

const ProvisioningHeader = () => {
    const { catalogCode, catalogServiceId } = useParams();
    const [order, setOrder] = useRecoilState(OrderPayload);
    const [, setCostEstimate] = useRecoilState(costEstimateState);
    const [members] = useRecoilState(selectedMembersList);
    const [appShortNameValid] = useRecoilState(isAppShortNameValid);
    const [appShortNameExist] = useRecoilState(isAppShortNameExist);
    const [applicationNameValid] = useRecoilState(isAppNameValid);
    const [, setiscostApiLoading] = useRecoilState(costApiLoading);
    const [cmpCatalogs] = useRecoilState(catalogs);

    const getCostPayload = () => {
        const day2Catalog = cmpCatalogs?.filter((catlg) => catlg?.catalogDefinitionId === catalogCode);
        const payload = costPayload({ order, catalogServiceId, day2Catalog });
        delete payload?.estimatedCost;
        return payload;
    };
    const cost = useMutation(() => axios.post(endPoints?.ssp?.costCalculation, getCostPayload()));

    React.useEffect(() => {
        if (cost?.isSuccess && cost.data?.data) {
            if (cost.data?.data) setCostEstimate(cost.data?.data);
            setOrder({ ...order, estimatedCost: cost.data?.data });
            setiscostApiLoading(false);
        }
        // eslint-disable-next-line
    }, [cost?.isSuccess]);
    useEffect(() => {
        setCostEstimate({ ...resetCostEstimateDetails, details: order?.emptyCost?.costs });
        const isValid = isReadyToGetCost({ order, appShortNameValid, appShortNameExist, applicationNameValid })?.isValid;
        if (isValid && order?.groupType === AD_GROUP && order?.adGroupType === PRIVILEGED) {
            setiscostApiLoading(true);
            cost.mutate();
        }
    }, [
        order?.typeOfRequest,
        order?.adGroup,
        order?.adGroupType,
        members,
        order?.appShortName,
        order?.groupOwner,
        order?.adGroupType,
        order?.applicationName,
        order?.businessApplication,
        order?.environment,
        order?.sector,
        order?.mypamsafeDetails,
        order?.nonSafeDetailsGpid,
        order?.groupType,
    ]);

    const getDisImage = (code) => {
        if (cmpCatalogs?.length) {
            const result = cmpCatalogs.find((service) => service.catalogDefinitionId === code);
            return `/${result?.iconPath}`;
        }
        return null;
    };

    return (
        <Box>
            <StickyHeader
                title="LDAP & Active Directory Group Membership"
                sx={ProvisioningStyles.ProvisioningHeader}
                width="40px"
                infoTitle="Click here for further details"
                imgSrc={getDisImage(catalogCode)}
            />
        </Box>
    );
};

export default React.memo(ProvisioningHeader);
